import React, {useEffect, useState} from 'react';
import Api from '../../../../interface/api/host';
import {Page} from "../../../../interface/model/page";
import {Pagination} from "../../../../component/paging";
import {ManagementMenuOptionItem, ManagementMenuOptionItem2} from "../../../../component/menu-item";

export default function StaffManage() {
    const siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
    const [ hostInfos, setHostInfos ] = useState<Page>();

    function excelUpload(e) {
        let fileName = e.target.files[0].name;
        if(fileName.split('.')[1]==='xlsx') {
            Api.uploadByExcel(siteInfo.seq, e.target.files[0]).then(res => {
                alert('정상적으로 등록되었어요.');
                // setTagList(tagList.concat(res.data));
                window.location.reload();
            })
        } else {
            alert('엑셀파일만 업로드가 가능해요.');
        }
    }

    function deleteHandler(hostInfo) {
        Api.deleteHostInfo(hostInfo.number).then(res => {
            alert('정상적으로 삭제되었습니다.');
            window.location.reload();
        })

        return null;
    }

    function excelDownload() {
        window.location.href=`/v1/host-info/excel/download?siteInfoSeq=${siteInfo.seq}`;
    }

    function fileClickHandler() {
        document.getElementById('file').click();
    }

    function pageMoveHandler(pageNumber) {
        Api.hostInfoListByPage(siteInfo.seq, pageNumber).then(res => setHostInfos(res.data));
    }

    useEffect(() => {
        Api.hostInfoList(siteInfo.seq).then(res => setHostInfos(res.data));
    },[])

    return (
        <>
            <div className="nv_contents">
                <div className="nv_m_btn_area nv_bord_btn_area">
                    {/* <button type="button" className="nv_blue_button right" style={{marginRight: '30px'}} onclick="javascript:fn_modal2on()">임직원 추가</button> */}
                    {/*<button type="button" className="nv_blue_button right" style={{marginRight: '30px'}}>임직원 추가</button>*/}
                        <input type="file"
                            id="file" accept={'.xlsx'}
                            style={{display:'none'}}
                            onChange={(e) => excelUpload(e)}
                        />
                    <button type="button" className="nv_green_button down_icon_btn m_skip" onClick={fileClickHandler} style={{marginLeft: '30px'}}>엑셀 업로드</button>
                    <button type="button" className="nv_green_button down_icon_btn m_skip" onClick={excelDownload} style={{marginLeft: '30px'}}>엑셀 다운로드</button>
                </div>
                <div className="nv_table_box">
                    <table className="nv_table textcenter" id="staffTable">
                        <colgroup>
                            <col style={{width: '10%'}}/>
                            <col style={{width: '15%'}}/>
                            <col style={{width: '20%'}}/>
                            <col style={{width: '15%'}}/>
                            <col style={{width: '15%'}}/>
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="row">회사</th>
                                <th scope="row">팀</th>
                                <th scope="row">사번</th>
                                <th scope="row">이름</th>
                                <th scope="row">이메일</th>
                                <th scope="row">권한</th>
                                <th scope="row">관리</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            hostInfos!==undefined && hostInfos.content.map((row, index) => (
                                <tr key={`hostInfosKey-${index}`}>
                                    <td>{`${row.siteInfo.parentSiteInfo.name}, ${row.siteInfo.name}`}</td>
                                    <td>{row.team}</td>
                                    <td>{row.number}</td>
                                    <td>{row.name}</td>
                                    <td>{row.email}</td>
                                    <td>임직원</td>
                                    <td>
                                        <ManagementMenuOptionItem items={[
                                            {
                                                innerHTML:'삭제',
                                                onClickHandler:() => deleteHandler(row)
                                            }
                                        ]}/>
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                        <tfoot></tfoot>
                    </table>
                    <Pagination page={hostInfos} pageMoveHandler={pageMoveHandler} />
                </div>
            </div>
        </>
    )
}